function herospaceSlider() {
  $(document).ready(function() {
    if ($('#herospace_slider').length) {
      var splideSlider = new Splide('#herospace_slider', {
        type: 'fade',
        perPage: 1,
        focus: 'center',
        autoplay: true,
        arrows: true,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        rewind: true,
        label: 'Herospace slider',
        labelledby: 'Herospace slider',
        role: 'banner',
      });

      splideSlider.mount();
    }
  });
}
